import { Service } from "utils/services";
import { useTranslation } from "react-i18next";
import { PostReaction } from "models/postReaction";

export default function TotalCommentReaction({
  post,
  onOpenReactionDialog,
}: {
  post: any;
  onOpenReactionDialog: (post: any, postReaction: PostReaction) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row items-center justify-between w-full">
      <div className="flex ">
        <div className="flex flex-row">
          {/* Comment */}
          {Service.toInteger(post?.comment_count) > 0 && (
            <p
              className="font-normal hover:underline cursor-pointer mr-1"
              onClick={() => onOpenReactionDialog(post, PostReaction.comment)}
            >{`${post?.comment_count} ${
              Service.toInteger(post?.comment_count) > 1
                ? t("Comments")
                : t("Comment")
            }`}</p>
          )}
        </div>
      </div>
    </div>
  );
}

